import React, {useState, useContext, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { signIn, confirmSignIn } from 'aws-amplify/auth';
import PasswordStrengthIndicator from '../../components/passwordStrengthIndicator';
import { useSnackbar } from 'notistack';
import { ProductContext } from '../../ProductProvider';
import Preloader from '../../components/Preloader/Preloader';
import logo from '../../images/logo/logo-new.png';
import { RoutesLocal } from '../../routes';
import {Helmet} from 'react-helmet-async';

import '../../login-modern.css';

const isNumberRegx = /\d/;
const specialCharacterRegx = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
const capsRegx=/[A-Z ]+/;
const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export default function Login() {
   const { validateLogin, loginValidated, setLoginValidated, loggedUser, setIsSidebarOpen } = useContext(ProductContext);
    const { enqueueSnackbar } = useSnackbar();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showNewPass, setShowNewPass] = useState(false);
    const [newPassword, setNewPassword]=useState('');
    const [loaded, setLoaded] = useState(true);
    const [passwordValidity, setPasswordValidity] = useState({
        minChar: null,
        number: null,
        specialChar: null,
        capsChar:null
      });
      const [passwordFocused, setPasswordFocused] = useState(false);
      const [newpasswordFocused, setNewPasswordFocused] = useState(false);
      const [newpasswordValidity, setNewPasswordValidity] = useState({
        minChar: null,
        number: null,
        specialChar: null,
        capsChar:null
      });
    
      useEffect(() => {
        if(!loggedUser.isAuthenticated && !loginValidated){
          setLoginValidated(true);
          validateLogin();
        }else{
          setIsSidebarOpen(true);
        }
      }, [])
    

const handleLogin = async(event) => {
    event.preventDefault();
    try{
        setLoaded(false);
        setNewPasswordFocused(false);
        if(username===""||password===""){
          enqueueSnackbar("Username and Password cannot be empty",{variant:'info'});
          setLoaded(true);
        }else if(!username.match(validRegex)){
          enqueueSnackbar("Enter your registered eamil address!",{variant:'info'});
        }else{
     await signIn({ 
      username, 
      password,
      })
     .then(async(user)=>{
      //console.log("User" , user);
      if(!user.isSignedIn && user.nextStep.signInStep==="CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED"){
        //setUser(user);
        setPasswordFocused(false);
        setShowNewPass(true);
        enqueueSnackbar("Set up your New Password",{variant:'info'});
      }else{  
        await validateLogin();
     }
     setLoaded(true);
    })
     .catch((error)=>{
      //console.log("Error :", error);
      setLoaded(true);
      enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
     })
  }
      }catch(error){
        //console.log("Error", error);
        setLoaded(true);
        enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});            
      }
  };
  
  const handleChangePassword =async(event)=>{
    event.preventDefault();
    try{
      setLoaded(false);
      const attributes = {
        email: username,
       };
       await confirmSignIn({
        challengeResponse: newPassword,
       })
      .then(async(user) => {
        //console.log(user);
        if(user.isSignedIn){
          await validateLogin();
          enqueueSnackbar("Authenticated Successfully!",{variant:'success'});
          setLoaded(true);    
        }
        //setSidebarStatus("Orginal");
    }).catch(e => {
      setLoaded(true);
      enqueueSnackbar("Error Occured - " + e.message,{variant : 'warning'});
    });
    }catch(error){
      setLoaded(true);
      enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
    }
  }
  
  const onChangePassword = password => {
    setPassword(password);
    setPasswordValidity({
        minChar: password.length >= 8 ? true : false,
        number: isNumberRegx.test(password) ? true : false,
        specialChar: specialCharacterRegx.test(password) ? true : false,
        capsChar:capsRegx.test(password)?true:false
    });
  };
  
  const onNewChangePassword = password => {
    setNewPassword(password);
    setNewPasswordValidity({
      minChar: password.length >= 8 ? true : false,
      number: isNumberRegx.test(password) ? true : false,
      specialChar: specialCharacterRegx.test(password) ? true : false,
      capsChar:capsRegx.test(password)?true:false
    });
  };
  
  return (
    <div className="login-modern-bg">
      <Helmet>
        <title>Sign In - Admin Office - VIDYAJYOTI JOURNAL OF THEOLOGICAL REFLECTION</title>
        <meta name="description" content="Sign In - Admin Office - VIDYAJYOTI JOURNAL OF THEOLOGICAL REFLECTION" />
        <meta name="keywords" content="Sign In - Admin Office - VIDYAJYOTI JOURNAL OF THEOLOGICAL REFLECTION" />
      </Helmet>
      {!loaded && <Preloader show={loaded ? false : true} />}
      <div className="login-modern-container">
        <div className="login-modern-card">
          <div className="login-modern-logo">
            <img width="120" src={logo} alt="Logo" />
            <h3>Admin Office - VIDYAJYOTI JOURNAL</h3>
          </div>
          <h2>Sign In</h2>
          <form className="login-modern-form">
            <div className="login-modern-field">
              <label>Email Address</label>
              <input
                type="email"
                name="email"
                placeholder="E-mail"
                onChange={event => setUsername(event.target.value)}
                value={username}
                autoComplete="username"
                className="login-modern-input"
              />
            </div>
            {!showNewPass ? (
              <div className="login-modern-field">
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  onFocus={() => setPasswordFocused(true)}
                  onChange={e => onChangePassword(e.target.value)}
                  value={password}
                  autoComplete="current-password"
                  className="login-modern-input"
                />
              </div>
            ) : (
              <div className="login-modern-field">
                <label>New Password</label>
                <input
                  type="password"
                  name="password"
                  placeholder="New Password"
                  onFocus={() => setNewPasswordFocused(true)}
                  onChange={e => onNewChangePassword(e.target.value)}
                  value={newPassword}
                  autoComplete="new-password"
                  className="login-modern-input"
                />
              </div>
            )}
            {passwordFocused && (
              <PasswordStrengthIndicator validity={passwordValidity} />
            )}
            {newpasswordFocused && (
              <PasswordStrengthIndicator validity={newpasswordValidity} />
            )}
            <div className="login-modern-actions">
              <Link className="login-modern-forgot" to={RoutesLocal.ForgotPassword.path}>
                Forgotten Password?
              </Link>
            </div>
            <div className="login-modern-actions">
              {!showNewPass ? (
                <button className="login-modern-btn" onClick={event => handleLogin(event)}>
                  Sign In
                </button>
              ) : (
                <button className="login-modern-btn" onClick={event => handleChangePassword(event)}>
                  Change Password
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
